interface Props {
  message?: string;
}

export const ErrorFallback = ({ message = 'sorry, not today' }: Props) => (
  <div className="fixed top-0 left-0 flex h-full w-full items-center justify-center" style={{ direction: 'ltr' }}>
    <div className="max-w-2xl px-10 font-mono">
      <p className="pb-2 text-2xl font-bold text-gray-600">Error :(</p>
      <p className="text-gray-400">{message}</p>
    </div>
  </div>
);
